import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import axios from '../api/axiosConfig';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import CargarCUPLModal from '../components/CargarCUPLModal';
import CargarLiquidacionModal from '../components/CargarLiquidacionModal';
import ConfirmarPreasignacionModal from '../components/ConfirmarPreasignacionModal';
import DetalleTramiteModal from '../components/DetalleTramiteModal';
import Pagination from '../components/Pagination';
import NovedadesTramiteModal from '../components/NovedadesTramiteModal';
import VerificarSoatsModal from '../components/VerificarSoatsModal';
import TramiteEliminacionesModal from '../components/TramiteEliminacionesModal';
import TramiteRequestDeletionModal from '../components/TramiteRequestDeletionModal';
import SolicitudesCambioPlacaModal from '../components/SolicitudesCambioPlacaModal';
import NoEjecutadoModal from '../components/NoEjecutadoModal';
import * as XLSX from 'xlsx';
import { generateTramiteExcelRow } from '../utils/exportExcelUtils';
import { AuthContext } from '../context/AuthContext';
import './Profiles.css';

const normalizeText = (str) => {
  if (!str) return '';
  return str
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();
};

const getUniqueOptions = (list, keyExtractor) => {
  const map = new Map();
  (list || []).forEach(item => {
    const rawVal = keyExtractor(item);
    if (!rawVal) return;
    const normKey = normalizeText(rawVal);
    if (!map.has(normKey)) {
      map.set(normKey, rawVal.trim());
    }
  });
  return Array.from(map.values()).sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));
};

const BandejaTransito = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const [pestana, setPestana] = useState(location.state?.pestana === 'otros' ? 'otros' : 'principal');
  const [tramites, setTramites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Estado para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [soatLoading, setSoatLoading] = useState(false);
  const [soatMessage, setSoatMessage] = useState('');

  // Estados para modales
  const [selectedTramite, setSelectedTramite] = useState(null);
  const [showCUPLModal, setShowCUPLModal] = useState(false);
  const [showLiquidacionModal, setShowLiquidacionModal] = useState(false);
  const [showPreassignModal, setShowPreassignModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showPendingCuplModal, setShowPendingCuplModal] = useState(false);
  const [showNoveltyModal, setShowNoveltyModal] = useState(false);
  const [selectedTramiteForNovelty, setSelectedTramiteForNovelty] = useState(null);
  const [showVerificarSoatsModal, setShowVerificarSoatsModal] = useState(false);
  const [showEliminacionesModal, setShowEliminacionesModal] = useState(false);
  const [showCambioPlacaModal, setShowCambioPlacaModal] = useState(false);
  const [pendingCambioPlacaCount, setPendingCambioPlacaCount] = useState(0);
  const [deletionRequests, setDeletionRequests] = useState([]);
  
  const [showRechazarModal, setShowRechazarModal] = useState(false);
  const [noEjecTramite, setNoEjecTramite] = useState(null);
  const [selectedTramiteForRechazo, setSelectedTramiteForRechazo] = useState(null);
  const [generandoCivitransId, setGenerandoCivitransId] = useState(null);

  const handleGenerarCivitransDirecto = async (tramiteId) => {
    try {
      setGenerandoCivitransId(tramiteId);
      const res = await axios.post(`/api/tramites/${tramiteId}/generar-factura-civitrans`);
      alert(`✅ ${res.data.message}`);
      fetchTramites();
    } catch (err) {
      console.error(err);
      alert(`❌ Error: ${err.response?.data?.message || err.message}`);
    } finally {
      setGenerandoCivitransId(null);
    }
  };

  // Estados para filtros de búsqueda
  const [searchTerm, setSearchTerm] = useState('');
  const [filterEstado, setFilterEstado] = useState('todos');
  const [filterType, setFilterType] = useState('todos');
  const [filterNovedad, setFilterNovedad] = useState(false);
  const [filterFactura, setFilterFactura] = useState(false);
  const [filterCreador, setFilterCreador] = useState('todos');
  const [filterConcesionario, setFilterConcesionario] = useState('todos');
  const [filterTransito, setFilterTransito] = useState('todos');
  const [filterStartDate, setFilterStartDate] = useState('');
  const [filterEndDate, setFilterEndDate] = useState('');
  const [filterOcultarEjecutados, setFilterOcultarEjecutados] = useState(false);

  useEffect(() => {
    fetchTramites();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const openId = location.state?.openTramiteId || params.get('openTramiteId');
    if (openId) {
      setSelectedTramite({ id: parseInt(openId) });
      setShowDetailModal(true);
    }
  }, [location]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterEstado, filterType, filterNovedad, filterFactura, filterCreador, filterConcesionario, filterTransito, filterStartDate, filterEndDate, filterOcultarEjecutados]);

  const fetchTramites = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/tramites');
      // Ahora res.data tiene estructura: { data: [...], pagination: {...} }
      const tramitesArray = Array.isArray(res.data) ? res.data : (res.data.data || []);
      
      // Mostrar trámites que ya pasaron por validación interna y están en el tránsito
      setTramites(tramitesArray.filter(t => ['radicado', 'pre_asignado', 'novedad_pendiente_soat', 'novedad_soat_cargado', 'novedad_soat_vigente', 'novedad_pendiente_cupl', 'novedad_cupl_generado', 'novedad_cupl_pagado', 'tramite_ejecutado', 'placa_en_camino', 'placa_entregada', 'placa_confirmada', 'incidencia_placa'].includes(t.estado)));
      
      try {
        const delRes = await axios.get('/api/tramites/deletion-requests');
        const deletionArray = Array.isArray(delRes.data) ? delRes.data : (delRes.data.data || []);
        setDeletionRequests(deletionArray);
      } catch (err) {
        console.error('Error fetching deletion requests', err);
      }

      try {
        const pcrRes = await axios.get('/api/plate-change/requests?status=pendiente');
        const pcrArray = Array.isArray(pcrRes.data) ? pcrRes.data : (pcrRes.data.data || []);
        setPendingCambioPlacaCount(pcrArray.length);
      } catch (err) {
        console.error('Error fetching plate change requests count', err);
      }
      
      setError('');
    } catch (err) {
      setError('Error al cargar la bandeja de tránsito');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmarPreasignado = (tramite) => {
    setSelectedTramite(tramite);
    setShowPreassignModal(true);
  };

  const handleEjecutarTramite = async (id) => {
    if (!window.confirm('¿Está seguro de finalizar y ejecutar este trámite? Esta acción es definitiva.')) return;
    try {
      await axios.put(`/api/tramites/${id}/estado`, { estado: 'tramite_ejecutado' });
      fetchTramites();
    } catch (err) {
      alert('Error al ejecutar el trámite');
    }
  };

  const handleRechazarTransito = async (reason) => {
    if (!selectedTramiteForRechazo) return;
    try {
      await axios.post(`/api/tramites/${selectedTramiteForRechazo.id}/rechazar_transito`, { reason });
      alert('Rechazo procesado exitosamente.');
      setShowRechazarModal(false);
      setSelectedTramiteForRechazo(null);
      fetchTramites();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al rechazar el trámite');
    }
  };

  const handleEliminarTramite = async (id) => {
    try {
      await axios.delete(`/api/tramites/${id}`);
      fetchTramites();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al eliminar el trámite');
    }
  };

  const handleOpenCUPL = (tramite) => {
    setSelectedTramite(tramite);
    setShowCUPLModal(true);
  };

  const handleOpenLiquidacion = (tramite) => {
    setSelectedTramite(tramite);
    setShowLiquidacionModal(true);
  };

  const handleOpenDetail = (tramite) => {
    setSelectedTramite(tramite);
    setShowDetailModal(true);
  };

  const handleOpenNovelty = (tramite) => {
    setSelectedTramiteForNovelty(tramite.id);
    setShowNoveltyModal(true);
  };

  const exportToExcel = () => {
    if (filteredTramites.length === 0) {
      alert('No hay datos para exportar con los filtros actuales.');
      return;
    }

    const exportData = filteredTramites.map(t => {
      const row = generateTramiteExcelRow(t, user, filterEstado);
      delete row['Concesionario'];
      delete row['Vendedor / Asesor'];
      delete row['Asesor / Creador'];
      delete row['Punto de Venta'];
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Trámites');
    XLSX.writeFile(workbook, `Bandeja_Transito_${new Date().toLocaleDateString('es-CO')}.xlsx`);
  };

  // Lógica de filtrado en memoria
  const filteredTramites = tramites.filter(t => {
    // Pestañas: "Otros trámites" (inscripción de prenda) se separan del resto
    if ((t.datos_adicionales?.tipo_flujo === 'otros_tramites') !== (pestana === 'otros')) return false;

    if (searchTerm.trim() !== '') {
      const term = searchTerm.toLowerCase();
      const idMatch = t.id.toString().includes(term);
      const placaMatch = (t.datos_adicionales?.placa_referencia || '').toLowerCase().includes(term);
      const ownerMatch = (t.datos_adicionales?.propietario || '').toLowerCase().includes(term);
      if (!idMatch && !placaMatch && !ownerMatch) return false;
    }

    if (filterEstado !== 'todos') {
      if (filterEstado === 'pre_asignado') {
        if (t.estado !== 'pre_asignado') return false;
      } else if (filterEstado === 'novedad_soat_vigente') {
        if (!(t.datos_adicionales?.soat_aprobado === true || t.estado === filterEstado)) return false;
      } else if (filterEstado === 'novedad_soat_cargado') {
        if (!(t.datos_adicionales?.soat_cargado === true || t.estado === filterEstado)) return false;
      } else if (filterEstado === 'novedad_cupl_generado') {
        if (!(t.datos_adicionales?.cupl_cargado === true || t.estado === filterEstado)) return false;
      } else if (filterEstado === 'novedad_cupl_pagado') {
        if (!(t.datos_adicionales?.cupl_pagado === true || t.estado === filterEstado)) return false;
      } else if (filterEstado === 'tramite_ejecutado') {
        if (!['tramite_ejecutado', 'placa_en_camino', 'placa_entregada', 'placa_confirmada', 'incidencia_placa'].includes(t.estado)) return false;
      } else {
        if (t.estado !== filterEstado) return false;
      }
    }

    if (filterType !== 'todos') {
      if (normalizeText(t.tramite_type_name) !== normalizeText(filterType)) return false;
    }

    if (filterNovedad) {
      if (!(t.pending_novelties_count > 0)) return false;
    }

    if (filterFactura) {
      if (t.factura_count !== 0 || t.datos_adicionales?.tipo_flujo === 'otros_tramites') return false;
    }

    if (filterCreador !== 'todos') {
      if (normalizeText(t.creador_name) !== normalizeText(filterCreador)) return false;
    }

    if (filterConcesionario !== 'todos') {
      if (normalizeText(t.creador_concesionario_name) !== normalizeText(filterConcesionario)) return false;
    }

    if (filterTransito !== 'todos') {
      if (normalizeText(t.transito_name) !== normalizeText(filterTransito)) return false;
    }


    if (filterOcultarEjecutados) {
      if (['tramite_ejecutado', 'placa_en_camino', 'placa_entregada', 'placa_confirmada', 'incidencia_placa'].includes(t.estado)) {
        return false;
      }
    }

    if (filterStartDate) {
      let dateToCompare = t.created_at;
      if (filterEstado !== 'todos') {
        if (filterEstado === 'tramite_ejecutado') {
          if (!t.fecha_ejecutado) return false;
          dateToCompare = t.fecha_ejecutado;
        } else if (filterEstado === 'pre_asignado') {
          if (!t.fecha_preasignacion) return false;
          dateToCompare = t.fecha_preasignacion;
        } else {
          dateToCompare = t.updated_at || t.created_at;
        }
      }
      if (new Date(dateToCompare) < new Date(filterStartDate + 'T00:00:00')) return false;
    }

    if (filterEndDate) {
      let dateToCompare = t.created_at;
      if (filterEstado !== 'todos') {
        if (filterEstado === 'tramite_ejecutado') {
          if (!t.fecha_ejecutado) return false;
          dateToCompare = t.fecha_ejecutado;
        } else if (filterEstado === 'pre_asignado') {
          if (!t.fecha_preasignacion) return false;
          dateToCompare = t.fecha_preasignacion;
        } else {
          dateToCompare = t.updated_at || t.created_at;
        }
      }
      if (new Date(dateToCompare) > new Date(filterEndDate + 'T23:59:59')) return false;
    }

    return true;
  });

  // Los trámites "radicado" (recién llegados, aún sin pre-asignar) van siempre arriba,
  // para que no se le pasen a tránsito. Dentro de cada grupo se ordena por fecha de radicación (más antiguo primero).
  const sortedTramites = [...filteredTramites].sort((a, b) => {
    const aRadicado = a.estado === 'radicado' && a.datos_adicionales?.tipo_flujo !== 'otros_tramites';
    const bRadicado = b.estado === 'radicado' && b.datos_adicionales?.tipo_flujo !== 'otros_tramites';
    if (aRadicado !== bRadicado) return aRadicado ? -1 : 1;
    return new Date(a.created_at) - new Date(b.created_at);
  });

  // Lógica de paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedTramites.slice(indexOfFirstItem, indexOfLastItem);

  // Trámites sin radicar (pendientes de pre-asignación), agrupados por tránsito.
  // Solo cuenta lo que ve el tránsito de la sesión; un superadmin ve el desglose de todos.
  const esOtroT = (t) => t.datos_adicionales?.tipo_flujo === 'otros_tramites';
  const radicadosPendientes = tramites.filter(t => t.estado === 'radicado' && !esOtroT(t));
  const radicadosPorTransito = getUniqueOptions(radicadosPendientes, t => t.transito_name).map(nombre => {
    const delTransito = radicadosPendientes.filter(t => normalizeText(t.transito_name) === normalizeText(nombre));
    return {
      nombre,
      count: delTransito.length,
      placas: delTransito.map(t => t.datos_adicionales?.placa_referencia || `#${t.id}`)
    };
  });

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  const getEstadoLabel = (estado) => {
    const labels = {
      'radicado': 'Radicado',
      'pre_asignado': 'Pre-Asignado',
      'novedad_pendiente_soat': 'SOAT Pendiente',
      'novedad_soat_cargado': 'SOAT Cargado',
      'novedad_soat_vigente': 'SOAT Vigente',
      'novedad_pendiente_cupl': 'CUPL Pendiente',
      'novedad_cupl_generado': 'CUPL Generado',
      'novedad_cupl_pagado': 'CUPL Pagado',
      'tramite_ejecutado': 'Trámite Ejecutado',
      'placa_en_camino': 'Placa en Camino',
      'placa_entregada': 'Placa Entregada',
      'placa_confirmada': 'Placa Confirmada',
      'incidencia_placa': 'Incidencia Placa'
    };
    return labels[estado] || estado;
  };

  const handleDownloadExcel = () => {
    exportToExcel();
  };

  const readyToMatricular = tramites.filter(t => 
    t.estado === 'novedad_cupl_pagado' && 
    t.datos_adicionales && 
    (t.datos_adicionales.soat_cargado === true || t.datos_adicionales.soat_aprobado === true) &&
    (!t.pending_novelties_count || t.pending_novelties_count === 0) &&
    (t.factura_count > 0 || t.datos_adicionales.tipo_flujo === 'otros_tramites')
  );

  return (
    <div className="app-layout">
      <Sidebar />

      <div className="main-content">
        <Navbar title="📥 Bandeja de Entrada Tránsito" />

        <div className="page-content">
          {error && <div className="error-banner">{error}</div>}
          {soatMessage && (
            <div style={{ padding: '15px', backgroundColor: '#dcfce7', color: '#166534', borderRadius: '8px', marginBottom: '20px', border: '1px solid #bbf7d0', fontWeight: 'bold' }}>
              {soatMessage}
            </div>
          )}
          {readyToMatricular.length > 0 && (
            <div style={{ 
              padding: '16px 20px', 
              backgroundColor: '#eff6ff', 
              color: '#1e40af', 
              borderRadius: '12px', 
              marginBottom: '20px', 
              border: '1px solid #bfdbfe', 
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              boxShadow: '0 4px 6px -1px rgba(30, 64, 175, 0.05), 0 2px 4px -1px rgba(30, 64, 175, 0.03)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 'bold', fontSize: '15px' }}>
                <span>🎉</span>
                <span>¡Trámites Listos para Matricular!</span>
                <span style={{ 
                  backgroundColor: '#2563eb', 
                  color: 'white', 
                  padding: '2px 8px', 
                  borderRadius: '9999px', 
                  fontSize: '12px', 
                  marginLeft: '4px' 
                }}>
                  {readyToMatricular.length}
                </span>
              </div>
              <div style={{ fontSize: '13px', color: '#1e3a8a', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <p style={{ margin: 0 }}>Los siguientes trámites cuentan con SOAT vigente y su CUPL correspondiente pagado, por lo que están listos para proceder con la matrícula inicial:</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '4px' }}>
                  {readyToMatricular.map(t => (
                    <span 
                      key={t.id} 
                      style={{ 
                        backgroundColor: '#dbeafe', 
                        padding: '4px 10px', 
                        borderRadius: '6px', 
                        fontSize: '12px', 
                        fontWeight: '600',
                        border: '1px solid #93c5fd'
                      }}
                    >
                      Trámite #{t.id} {t.datos_adicionales?.placa_referencia ? `(${t.datos_adicionales.placa_referencia})` : ''} - {t.datos_adicionales?.propietario}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}

          {(() => {
            const otrosActivos = tramites.filter(t => esOtroT(t) && t.estado !== 'tramite_ejecutado' && t.estado !== 'rechazado').length;
            const tabStyle = (activa) => ({
              padding: '10px 20px', border: 'none', cursor: 'pointer', fontWeight: '800', fontSize: '13px',
              borderBottom: activa ? '3px solid #7c3aed' : '3px solid transparent',
              background: 'transparent', color: activa ? '#5b21b6' : 'var(--text-secondary)'
            });
            return (
              <>
                <div style={{ display: 'flex', gap: '4px', borderBottom: '1px solid var(--card-border)', marginBottom: '16px' }}>
                  <button type="button" style={tabStyle(pestana === 'principal')} onClick={() => setPestana('principal')}>📋 Trámites</button>
                  <button type="button" style={tabStyle(pestana === 'otros')} onClick={() => setPestana('otros')}>
                    📂 Otros trámites{otrosActivos > 0 ? ` (${otrosActivos})` : ''}
                  </button>
                </div>
                {pestana === 'principal' && otrosActivos > 0 && (
                  <div style={{
                    padding: '12px 20px', backgroundColor: '#f5f3ff', color: '#5b21b6', borderRadius: '12px',
                    marginBottom: '20px', border: '1px solid #c4b5fd', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap'
                  }}>
                    <span style={{ fontWeight: '700', fontSize: '13px' }}>
                      📂 Hay {otrosActivos} {otrosActivos === 1 ? 'trámite' : 'trámites'} en la pestaña "Otros trámites" (inscripción de prenda, duplicado de licencia).
                    </span>
                    <button type="button" className="btn-action" onClick={() => setPestana('otros')}
                      style={{ marginLeft: 'auto', fontWeight: '800' }}>Ver 🔍</button>
                  </div>
                )}
              </>
            );
          })()}

          {pestana === 'principal' && radicadosPendientes.length > 0 && (
            <div style={{
              padding: '16px 20px',
              backgroundColor: '#fef3c7',
              color: '#92400e',
              borderRadius: '12px',
              marginBottom: '20px',
              border: '1px solid #fde68a',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              boxShadow: '0 4px 6px -1px rgba(217, 119, 6, 0.05)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 'bold', fontSize: '15px' }}>
                <span>📝</span>
                <span>Trámites sin radicar</span>
                <span style={{
                  backgroundColor: '#d97706',
                  color: 'white',
                  padding: '2px 8px',
                  borderRadius: '9999px',
                  fontSize: '12px',
                  marginLeft: '4px'
                }}>
                  {radicadosPendientes.length}
                </span>
              </div>
              {radicadosPorTransito.length > 1 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '13px' }}>
                  {radicadosPorTransito.map(({ nombre, count, placas }) => (
                    <div key={nombre} style={{ backgroundColor: '#fef9c3', padding: '6px 10px', borderRadius: '6px', border: '1px solid #fde68a' }}>
                      <strong>{nombre}: {count}</strong>
                      <span style={{ marginLeft: '6px', color: '#78350f' }}>({placas.join(', ')})</span>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ margin: 0, fontSize: '13px' }}>
                  Faltan por pre-asignar {radicadosPendientes.length === 1 ? 'este trámite' : 'estos trámites'}
                  {radicadosPorTransito.length === 1 ? ` de ${radicadosPorTransito[0].nombre}` : ''}:
                  {' '}<strong>{radicadosPorTransito[0]?.placas.join(', ')}</strong>
                </p>
              )}
            </div>
          )}

          {pendingCambioPlacaCount > 0 && (
            <div className="alert-banner info" style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '16px 24px',
              backgroundColor: '#eff6ff',
              border: '1px solid #bfdbfe',
              borderRadius: '12px',
              marginBottom: '20px',
              color: '#1e40af',
              fontSize: '15px',
              fontWeight: '500',
              boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.05)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '20px' }}>📩</span>
                <span>
                  Tienes <strong>{pendingCambioPlacaCount}</strong> {pendingCambioPlacaCount === 1 ? 'solicitud' : 'solicitudes'} pendiente{pendingCambioPlacaCount === 1 ? '' : 's'} de <strong>cambio de placa / eliminación por traslado de tránsito</strong>.
                </span>
              </div>
              <button 
                onClick={() => setShowCambioPlacaModal(true)} 
                className="btn-primary" 
                style={{
                  marginLeft: 'auto',
                  padding: '8px 16px',
                  fontSize: '13px',
                  backgroundColor: '#2563eb',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '700'
                }}
              >
                Revisar Solicitudes ➡️
              </button>
            </div>
          )}

          <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
            <div className="header-title">
              <h2>Trámites en Curso</h2>
              <p className="subtitle">Gestión de trámites para la generación de CUPL y pre-asignación</p>
            </div>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>

              <button 
                className="btn-action" 
                onClick={() => setShowPendingCuplModal(true)}
                style={{ 
                  background: 'var(--warning-soft, #fef3c7)', 
                  color: 'var(--warning-color, #d97706)', 
                  border: '1px solid rgba(217, 119, 6, 0.2)', 
                  padding: '10px 16px', 
                  borderRadius: '8px', 
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}
              >
                📋 Pendientes de CUPL ({tramites.filter(t => t.estado === 'novedad_pendiente_cupl').length})
              </button>

              <button 
                className="btn-action" 
                onClick={() => setShowCambioPlacaModal(true)}
                style={{ 
                  background: '#dbeafe', 
                  color: '#2563eb', 
                  border: '1px solid #bfdbfe', 
                  padding: '10px 16px', 
                  borderRadius: '8px', 
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}
              >
                📩 Cambio de Placa / Traslado ({pendingCambioPlacaCount})
              </button>

              <button 
                className="btn-action" 
                onClick={() => setShowEliminacionesModal(true)}
                style={{ 
                  background: 'var(--danger-soft, #fef2f2)', 
                  color: 'var(--danger-color, #ef4444)', 
                  border: '1px solid rgba(239, 68, 68, 0.2)', 
                  padding: '10px 16px', 
                  borderRadius: '8px', 
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}
              >
                🗑️ Eliminaciones ({deletionRequests.length})
              </button>

              {(user?.role === 'superadmin' || user?.profile_name === 'superadmin') && (
                <button 
                  className="btn-action" 
                  onClick={() => setShowVerificarSoatsModal(true)} 
                  style={{ 
                    background: 'var(--primary-color, #2563eb)', 
                    color: 'white', 
                    border: 'none', 
                    padding: '10px 16px', 
                    borderRadius: '8px', 
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                >
                  🛡️ Verificar SOATs automáticos
                </button>
              )}
            </div>
          </div>

          {/* Barra de Filtros */}
          <div className="dashboard-filters" style={{ 
            display: 'flex', 
            gap: '15px', 
            background: 'var(--card-bg)', 
            padding: '16px 24px', 
            borderRadius: '14px', 
            alignItems: 'center', 
            flexWrap: 'wrap',
            boxShadow: 'var(--card-shadow)',
            border: '1px solid var(--card-border)',
            marginBottom: '20px'
          }}>
            <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px', flex: '1 1 200px' }}>
              <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Buscar:</label>
              <input
                type="text"
                placeholder="ID, Placa o Propietario..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ 
                  padding: '10px 14px', 
                  border: '1px solid var(--input-border)', 
                  borderRadius: '10px', 
                  background: 'var(--input-bg)', 
                  color: 'var(--text-primary)', 
                  fontSize: '13px', 
                  fontWeight: '500', 
                  outline: 'none',
                  width: '100%'
                }}
              />
            </div>

            <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '180px' }}>
              <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Estado:</label>
              <select
                value={filterEstado}
                onChange={(e) => setFilterEstado(e.target.value)}
                style={{ 
                  padding: '10px 14px', 
                  border: '1px solid var(--input-border)', 
                  borderRadius: '10px', 
                  background: 'var(--input-bg)', 
                  color: 'var(--text-primary)', 
                  fontSize: '13px', 
                  fontWeight: '500', 
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value="todos">📋 Todos los Estados</option>
                <option value="radicado">📝 Radicado</option>
                <option value="pre_asignado">🚗 Pre-Asignado</option>
                <option value="novedad_pendiente_soat">📄 SOAT Pendiente</option>
                <option value="novedad_soat_cargado">🛡️ SOAT Cargado</option>
                <option value="novedad_soat_vigente">🛡️ SOAT Vigente</option>
                <option value="novedad_pendiente_cupl">💳 CUPL Pendiente</option>
                <option value="novedad_cupl_generado">📄 CUPL Generado</option>
                <option value="novedad_cupl_pagado">💳 CUPL Pagado</option>
                <option value="tramite_ejecutado">🎉 Trámite Ejecutado</option>
                <option value="placa_en_camino">🚚 Placa en Camino</option>
                <option value="placa_entregada">🏪 Placa Entregada</option>
                <option value="placa_confirmada">✅ Placa Confirmada</option>
                <option value="incidencia_placa">⚠️ Incidencia Placa</option>
              </select>
            </div>

            <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '180px' }}>
              <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Tipo de Trámite:</label>
              <select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                style={{ 
                  padding: '10px 14px', 
                  border: '1px solid var(--input-border)', 
                  borderRadius: '10px', 
                  background: 'var(--input-bg)', 
                  color: 'var(--text-primary)', 
                  fontSize: '13px', 
                  fontWeight: '500', 
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value="todos">🔧 Todos los Tipos</option>
                {getUniqueOptions(tramites, t => t.tramite_type_name).map(type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>

            {(user?.role === 'superadmin' || user?.profile_name === 'superadmin') && (
              <>
                <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '180px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Concesionario:</label>
                  <select
                    value={filterConcesionario}
                    onChange={(e) => setFilterConcesionario(e.target.value)}
                    style={{ 
                      padding: '10px 14px', 
                      border: '1px solid var(--input-border)', 
                      borderRadius: '10px', 
                      background: 'var(--input-bg)', 
                      color: 'var(--text-primary)', 
                      fontSize: '13px', 
                      fontWeight: '500', 
                      outline: 'none',
                      cursor: 'pointer'
                    }}
                  >
                    <option value="todos">🏢 Todos los Concesionarios</option>
                    {getUniqueOptions(tramites, t => t.creador_concesionario_name).map(conc => (
                      <option key={conc} value={conc}>{conc}</option>
                    ))}
                  </select>
                </div>

                <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '180px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Creador:</label>
                  <select
                    value={filterCreador}
                    onChange={(e) => setFilterCreador(e.target.value)}
                    style={{ 
                      padding: '10px 14px', 
                      border: '1px solid var(--input-border)', 
                      borderRadius: '10px', 
                      background: 'var(--input-bg)', 
                      color: 'var(--text-primary)', 
                      fontSize: '13px', 
                      fontWeight: '500', 
                      outline: 'none',
                      cursor: 'pointer'
                    }}
                  >
                    <option value="todos">👤 Todos los Creadores</option>
                    {getUniqueOptions(tramites, t => t.creador_name).map(creator => (
                      <option key={creator} value={creator}>{creator}</option>
                    ))}
                  </select>
                </div>
              </>
            )}


            {user?.role === 'superadmin' && (
              <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '180px' }}>
                <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Tránsito:</label>
                <select
                  value={filterTransito}
                  onChange={(e) => setFilterTransito(e.target.value)}
                  style={{ 
                    padding: '10px 14px', 
                    border: '1px solid var(--input-border)', 
                    borderRadius: '10px', 
                    background: 'var(--input-bg)', 
                    color: 'var(--text-primary)', 
                    fontSize: '13px', 
                    fontWeight: '500', 
                    outline: 'none',
                    cursor: 'pointer'
                  }}
                >
                  <option value="todos">🏛️ Todos los Tránsitos</option>
                  {getUniqueOptions(tramites, t => t.transito_name).map(tr => (
                    <option key={tr} value={tr}>{tr}</option>
                  ))}
                </select>
              </div>
            )}

            <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '140px' }}>
              <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Fecha Inicio:</label>
              <input
                type="date"
                value={filterStartDate}
                onChange={(e) => setFilterStartDate(e.target.value)}
                style={{ 
                  padding: '10px 14px', 
                  border: '1px solid var(--input-border)', 
                  borderRadius: '10px', 
                  background: 'var(--input-bg)', 
                  color: 'var(--text-primary)', 
                  fontSize: '13px', 
                  fontWeight: '500', 
                  outline: 'none',
                  cursor: 'pointer'
                }}
              />
            </div>

            <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '140px' }}>
              <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Fecha Fin:</label>
              <input
                type="date"
                value={filterEndDate}
                onChange={(e) => setFilterEndDate(e.target.value)}
                style={{ 
                  padding: '10px 14px', 
                  border: '1px solid var(--input-border)', 
                  borderRadius: '10px', 
                  background: 'var(--input-bg)', 
                  color: 'var(--text-primary)', 
                  fontSize: '13px', 
                  fontWeight: '500', 
                  outline: 'none',
                  cursor: 'pointer'
                }}
              />
            </div>

            <div className="checkbox-filters" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginTop: '10px' }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                fontSize: '13px', 
                fontWeight: '600', 
                color: 'var(--text-primary)', 
                cursor: 'pointer',
                userSelect: 'none'
              }}>
                <input
                  type="checkbox"
                  checked={filterNovedad}
                  onChange={(e) => setFilterNovedad(e.target.checked)}
                  style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                />
                ⚠️ Con Novedades
              </label>

              <label style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                fontSize: '13px', 
                fontWeight: '600', 
                color: 'var(--text-primary)', 
                cursor: 'pointer',
                userSelect: 'none'
              }}>
                <input
                  type="checkbox"
                  checked={filterFactura}
                  onChange={(e) => setFilterFactura(e.target.checked)}
                  style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                />
                ⚠️ Sin Factura
              </label>

              <label style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                fontSize: '13px', 
                fontWeight: '600', 
                color: 'var(--text-primary)', 
                cursor: 'pointer',
                userSelect: 'none'
              }}>
                <input
                  type="checkbox"
                  checked={filterOcultarEjecutados}
                  onChange={(e) => setFilterOcultarEjecutados(e.target.checked)}
                  style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                />
                🙈 Ocultar Ejecutados
              </label>
            </div>

            <button 
              onClick={() => {
                setSearchTerm('');
                setFilterEstado('todos');
                setFilterType('todos');
                setFilterCreador('todos');
                setFilterConcesionario('todos');
                setFilterTransito('todos');
                setFilterStartDate('');
                setFilterEndDate('');
                setFilterNovedad(false);
                setFilterFactura(false);
                setFilterOcultarEjecutados(false);

              }}
              style={{
                marginLeft: 'auto',
                padding: '10px 16px',
                background: 'var(--secondary-soft)',
                color: 'var(--text-secondary)',
                border: '1px solid var(--card-border)',
                borderRadius: '10px',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '13px',
                marginTop: '15px',
                transition: 'all 0.2s'
              }}
            >
              🧹 Limpiar
            </button>
            <button 
              onClick={exportToExcel}
              style={{
                padding: '10px 16px',
                background: '#10b981',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '13px',
                marginTop: '15px',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: '5px'
              }}
            >
              📥 Excel
            </button>
          </div>

          {loading ? (
            <p className="loading">Cargando bandeja...</p>
          ) : (
            <div className="table-wrapper">
              <div className="table-responsive">
                <table className="users-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Tipo</th>
                    <th>Propietario</th>
                    <th>Placa</th>
                    <th>Cilindraje</th>
                    <th>Tránsito</th>
                    <th>Fecha Radicación</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map(t => (
                    <tr key={t.id} style={{ background: t.deletion_requested ? '#fee2e2' : '' }}>
                      <td data-label="ID">
                        <strong>#{t.id}</strong>
                        {t.deletion_requested && (
                          <div style={{ marginTop: '4px', fontSize: '10px', color: '#ef4444', fontWeight: 'bold' }}>
                            ⚠️ MARCADO PARA ELIMINACIÓN
                          </div>
                        )}
                      </td>
                      <td data-label="Tipo">{t.tramite_type_name}</td>
                      <td data-label="Propietario">
                        <div><strong>{t.datos_adicionales?.propietario || 'N/A'}</strong></div>
                        {(user?.role === 'superadmin' || user?.profile_name === 'superadmin') && (t.punto_venta_name || t.datos_adicionales?.punto_venta_factura || t.datos_adicionales?.punto_venta_nombre || t.datos_adicionales?.punto_venta) && (
                          <div style={{ fontSize: '11px', color: '#7c3aed', marginTop: '3px', fontWeight: '700' }}>
                            📍 {t.punto_venta_name || t.datos_adicionales?.punto_venta_factura || t.datos_adicionales?.punto_venta_nombre || t.datos_adicionales?.punto_venta}
                          </div>
                        )}
                        {(user?.role === 'superadmin' || user?.profile_name === 'superadmin') && (t.datos_adicionales?.asesor || t.datos_adicionales?.vendedor_factura) && (
                          <div style={{ fontSize: '10px', color: '#475569', marginTop: '2px', fontStyle: 'italic' }}>
                            👤 Asesor: {t.datos_adicionales.asesor || t.datos_adicionales.vendedor_factura}
                          </div>
                        )}
                        {(t.datos_adicionales?.observaciones || t.observaciones) && (
                          <div style={{ fontSize: '11px', color: '#0284c7', marginTop: '3px', fontStyle: 'italic' }} title={t.datos_adicionales?.observaciones || t.observaciones}>
                            💬 {t.datos_adicionales?.observaciones || t.observaciones}
                          </div>
                        )}
                      </td>
                      <td data-label="Placa">
                        {t.datos_adicionales?.placa_referencia ? (
                          <span className="plate-badge-sm">{t.datos_adicionales.placa_referencia}</span>
                        ) : '—'}
                        {t.pending_plate_change_number && (
                          <div style={{ marginTop: '4px' }}>
                            <span style={{ background: '#f59e0b', color: '#fff', fontSize: '10px', padding: '2px 6px', borderRadius: '8px', fontWeight: '800', display: 'inline-block' }}>
                              ⏳ Solicitada: {t.pending_plate_change_number}
                            </span>
                          </div>
                        )}
                      </td>
                      <td data-label="Cilindraje">
                        {(() => {
                          const v = t.datos_adicionales?.vehicleDetails?.vehiculo;
                          const cc = v?.cilindraje || v?.datos_completos?.rna?.datos?.cilindraje;
                          return cc ? `${cc} cc` : '—';
                        })()}
                      </td>
                      <td data-label="Tránsito">
                        <span style={{ background: '#e0e7ff', color: '#3730a3', padding: '2px 10px', borderRadius: '6px', fontWeight: '600', fontSize: '12px', whiteSpace: 'nowrap' }}>
                          {t.transito_name || '—'}
                        </span>
                      </td>
                      <td data-label="Fecha Radicación" style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#475569' }}>
                        {t.created_at ? new Date(t.created_at).toLocaleString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—'}
                      </td>
                      <td data-label="Estado">
                        <span className={`status ${
                           t.estado === 'radicado' ? 'pending' :
                           t.estado === 'pre_asignado' ? 'activo' : 
                           t.estado === 'novedad_soat_vigente' ? 'paid' : 
                           t.estado === 'novedad_cupl_pagado' ? 'paid' :
                           t.estado === 'tramite_ejecutado' ? 'paid' :
                           t.estado === 'placa_confirmada' ? 'paid' :
                           t.estado === 'incidencia_placa' ? 'expired' :
                           'warning'
                         }`}>
                          {t.estado === 'radicado' ? '📝 Radicado' :
                           t.estado === 'pre_asignado' ? 'Pre-Asignado' : 
                           t.estado === 'novedad_pendiente_soat' ? 'SOAT Pendiente' : 
                           t.estado === 'novedad_soat_cargado' ? 'SOAT Cargado' :
                           t.estado === 'novedad_soat_vigente' ? 'SOAT Vigente' :
                           t.estado === 'novedad_pendiente_cupl' ? 'CUPL Pendiente' :
                           t.estado === 'novedad_cupl_generado' ? 'CUPL Generado' :
                           t.estado === 'novedad_cupl_pagado' ? 'CUPL Pagado' :
                           t.estado === 'tramite_ejecutado' ? 'Trámite Ejecutado' :
                           t.estado === 'placa_en_camino' ? '🚚 Placa en Camino' :
                           t.estado === 'placa_entregada' ? '🏪 Placa Entregada' :
                           t.estado === 'placa_confirmada' ? '✅ Placa Confirmada' :
                           t.estado === 'incidencia_placa' ? '⚠️ Incidencia Placa' :
                           t.estado}
                        </span>
                        {t.estado === 'radicado' && t.datos_adicionales?.preasignacion_no_confirmada && (
                          <div role="alert" style={{
                            marginTop: '6px', padding: '6px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: '700',
                            background: '#fef3c7', color: '#92400e', border: '1px solid #f59e0b', maxWidth: '260px', whiteSpace: 'normal', lineHeight: 1.35
                          }}>
                            ⏳ Aún no está pre-asignada en RUNT.
                            <div style={{ fontWeight: 500, marginTop: '2px' }}>
                              {t.datos_adicionales.preasignacion_mensaje || 'Realice la pre-asignación en RUNT y vuelva a marcar "Pre-asignar".'}
                            </div>
                          </div>
                        )}
                        {t.pending_novelties_count > 0 && (
                          <div style={{ marginTop: '5px' }}>
                            <span style={{
                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontSize: '10px',
                              fontWeight: '900',
                              background: '#fee2e2',
                              color: '#dc2626',
                              border: '1px solid rgba(220, 38, 38, 0.2)',
                              whiteSpace: 'nowrap'
                            }} title={`Este trámite tiene ${t.pending_novelties_count} novedades pendientes`}>
                              ⚠️ NOVEDAD ({t.pending_novelties_count})
                            </span>
                          </div>
                        )}
                        {t.factura_count === 0 && !esOtroT(t) && (
                          <div style={{ marginTop: '5px' }}>
                            <span style={{
                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontSize: '10px',
                              fontWeight: '900',
                              background: '#fff7ed',
                              color: '#ea580c',
                              border: '1px solid rgba(234, 88, 12, 0.2)',
                              whiteSpace: 'nowrap'
                            }} title="Este trámite se creó sin factura adjunta">
                              ⚠️ SIN FACTURA
                            </span>
                          </div>
                        )}
                        {t.datos_adicionales?.total_liquidacion && (
                          <div style={{ marginTop: '5px' }}>
                            <span style={{
                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontSize: '10px',
                              fontWeight: '900',
                              background: '#d1fae5',
                              color: '#064e3b',
                              border: '1px solid rgba(6, 78, 59, 0.2)',
                              whiteSpace: 'nowrap'
                            }} title="Total de liquidación">
                              💰 LIQ: ${t.datos_adicionales.total_liquidacion.toLocaleString('es-CO')}
                            </span>
                          </div>
                        )}
                      </td>
                      <td data-label="Acciones" className="actions">
                        <button 
                          className="btn-action btn-view" 
                          onClick={() => handleOpenDetail(t)}
                        >
                          👁️ Ver
                        </button>
                        
                        {user?.profile_name !== 'auxiliar transiapp' && (
                          <>
                            <button 
                              className="btn-action" 
                              style={{
                                background: t.pending_novelties_count > 0 ? 'rgba(239, 68, 68, 0.1)' : 'rgba(100, 116, 139, 0.1)',
                                color: t.pending_novelties_count > 0 ? '#dc2626' : '#64748b',
                                border: t.pending_novelties_count > 0 ? '1px solid rgba(239, 68, 68, 0.2)' : '1px solid rgba(100, 116, 139, 0.2)',
                                fontWeight: '600'
                              }}
                              onClick={() => handleOpenNovelty(t)}
                            >
                              ⚠️ Novedades {t.pending_novelties_count > 0 && `(${t.pending_novelties_count})`}
                            </button>
                            
                            {(!t.datos_adicionales?.cupl_cargado && (t.pre_assigned_plate_id || esOtroT(t)) && t.estado !== 'tramite_ejecutado' && t.estado !== 'rechazado') && (
                              <button 
                                className="btn-action btn-modules" 
                                onClick={() => handleOpenCUPL(t)}
                              >
                                📄 CUPL
                              </button>
                            )}
                            
                            {!t.liquidacion_archivo_url && (user?.role === 'superadmin' || user?.transito_id || user?.role === 'transito' || user?.can_view_liquidacion) && (
                              <button 
                                className="btn-action" 
                                style={{ background: '#ecfdf5', color: '#10b981', border: '1px solid #10b981' }}
                                onClick={() => handleOpenLiquidacion(t)}
                              >
                                📄 Adjuntar Liq.
                              </button>
                            )}

                             {(t.transito_id === 4 || (t.transito_name && t.transito_name.toUpperCase().includes('SABANAGRANDE'))) && (t.factura_count === 0 || !t.datos_adicionales?.factura_electronica) && t.estado !== 'tramite_ejecutado' && t.estado !== 'rechazado' && (
                              <button
                                className="btn-action"
                                onClick={() => handleGenerarCivitransDirecto(t.id)}
                                disabled={generandoCivitransId === t.id}
                                style={{
                                  background: '#eff6ff',
                                  color: '#2563eb',
                                  border: '1px solid #3b82f6',
                                  fontWeight: '700'
                                }}
                                title="Generar y descargar factura PDF desde Civitrans Sabanagrande"
                              >
                                {generandoCivitransId === t.id ? '⏳ Generando...' : '⚡ Liquidación Civitrans'}
                              </button>
                             )}

                            {(t.estado === 'radicado' && !esOtroT(t)) && (
                              <button 
                                className="btn-action" 
                                style={{ background: 'var(--success-soft)', color: 'var(--success-color)', border: '1px solid var(--success-color)' }}
                                onClick={() => handleConfirmarPreasignado(t)}
                              >
                                ✅ Pre-asignar
                              </button>
                            )}

                            {(t.datos_adicionales?.soat_aprobado === true && t.datos_adicionales?.cupl_pagado === true && !['tramite_ejecutado', 'placa_en_camino', 'placa_entregada', 'placa_confirmada', 'incidencia_placa'].includes(t.estado) && (!t.pending_novelties_count || t.pending_novelties_count === 0) && (t.factura_count > 0 || esOtroT(t)) && !t.intento_ejecucion?.bloquea_finalizar) && (
                              <button 
                                className="btn-action" 
                                style={{ 
                                  background: 'var(--primary-soft)', 
                                  color: 'var(--primary-color)', 
                                  border: '1px solid var(--primary-color)',
                                  cursor: 'pointer'
                                }}
                                title="Finalizar y ejecutar trámite"
                                onClick={() => handleEjecutarTramite(t.id)}
                              >
                                🔒 Finalizar
                              </button>
                            )}

                            {(t.datos_adicionales?.soat_aprobado === true && t.datos_adicionales?.cupl_pagado === true && !['tramite_ejecutado', 'placa_en_camino', 'placa_entregada', 'placa_confirmada', 'incidencia_placa', 'rechazado', 'eliminado'].includes(t.estado) && !t.intento_ejecucion?.bloquea_finalizar && user?.profile_name !== 'auxiliar transiapp') && (
                              <button 
                                className="btn-action" 
                                style={{ background: '#fffbeb', color: '#b45309', border: '1px solid #fcd34d', cursor: 'pointer', fontWeight: '600' }}
                                title="Registrar intento de ejecución no exitoso"
                                onClick={() => setNoEjecTramite(t)}
                              >
                                ⛔ No ejecutado
                              </button>
                            )}
                            {t.intento_ejecucion && (
                              <span title={`${t.intento_ejecucion.motivo}${t.intento_ejecucion.observaciones ? ' - ' + t.intento_ejecucion.observaciones : ''} (${t.intento_ejecucion.usuario})`}
                                style={{ fontSize: '10px', color: '#92400e', background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: '4px', padding: '2px 6px', fontWeight: 600 }}>
                                ⛔ {t.intento_ejecucion.motivo}
                              </span>
                            )}


                            {(!['rechazado', 'tramite_ejecutado', 'placa_en_camino', 'placa_entregada', 'placa_confirmada', 'incidencia_placa', 'eliminado'].includes(t.estado)) && (
                              <button 
                                className="btn-action" 
                                style={{ 
                                  background: 'rgba(239, 68, 68, 0.1)', 
                                  color: '#ef4444', 
                                  border: '1px solid rgba(239, 68, 68, 0.2)',
                                  cursor: 'pointer',
                                  fontWeight: '600'
                                }}
                                title="Rechazar y devolver trámite"
                                onClick={() => {
                                  setSelectedTramiteForRechazo(t);
                                  setShowRechazarModal(true);
                                }}
                              >
                                ❌ Rechazar
                              </button>
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
              {filteredTramites.length === 0 && (
                <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
                  No hay trámites que coincidan con los filtros seleccionados.
                </div>
              )}
              
              <Pagination 
                currentPage={currentPage}
                totalItems={filteredTramites.length}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleItemsPerPageChange}
              />
            </div>
          )}
        </div>
      </div>

      <CargarCUPLModal 
        isOpen={showCUPLModal} 
        onClose={() => setShowCUPLModal(false)} 
        tramite={selectedTramite} 
        onSuccess={fetchTramites} 
      />

      <CargarLiquidacionModal 
        isOpen={showLiquidacionModal} 
        onClose={() => setShowLiquidacionModal(false)} 
        tramite={selectedTramite} 
        onSuccess={fetchTramites} 
      />

      <NoEjecutadoModal
        isOpen={!!noEjecTramite}
        tramite={noEjecTramite}
        onClose={() => setNoEjecTramite(null)}
        onSuccess={fetchTramites}
      />

      <ConfirmarPreasignacionModal
        isOpen={showPreassignModal}
        onClose={() => {
          setShowPreassignModal(false);
          setSelectedTramite(null);
        }}
        tramite={selectedTramite}
        onSuccess={fetchTramites}
      />

      <DetalleTramiteModal 
        isOpen={showDetailModal} 
        onClose={() => setShowDetailModal(false)} 
        tramiteId={selectedTramite?.id} 
        onUpdate={fetchTramites} 
      />

      <NovedadesTramiteModal 
        isOpen={showNoveltyModal} 
        tramiteId={selectedTramiteForNovelty} 
        onClose={() => {
          setShowNoveltyModal(false);
          setSelectedTramiteForNovelty(null);
        }} 
        onSuccess={fetchTramites} 
        readOnly={user?.role !== 'superadmin' && user?.role !== 'admin' && !user?.transito_id}
      />

      {showPendingCuplModal && (
        <div className="modal-overlay" onClick={() => setShowPendingCuplModal(false)}>
          <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '15px', borderBottom: '1px solid #e2e8f0' }}>
              <h3 style={{ margin: 0 }}>📋 Trámites Pendientes de CUPL</h3>
              <button 
                onClick={() => setShowPendingCuplModal(false)}
                style={{ border: 'none', background: 'none', fontSize: '20px', cursor: 'pointer', color: '#64748b' }}
              >
                &times;
              </button>
            </div>
            <div className="modal-body" style={{ padding: '20px 0' }}>
              {tramites.filter(t => t.estado === 'novedad_pendiente_cupl').length === 0 ? (
                <p style={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic', margin: '20px 0' }}>
                  No hay trámites pendientes de CUPL.
                </p>
              ) : (
                <div style={{ maxHeight: '350px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                  <div className="table-responsive">
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                    <thead>
                      <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                        <th style={{ padding: '12px 16px', fontWeight: 'bold', fontSize: '13px', color: '#475569' }}>Placa</th>
                        <th style={{ padding: '12px 16px', fontWeight: 'bold', fontSize: '13px', color: '#475569' }}>Tipo de Trámite</th>
                        <th style={{ padding: '12px 16px', fontWeight: 'bold', fontSize: '13px', color: '#475569' }}>Tránsito</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tramites.filter(t => t.estado === 'novedad_pendiente_cupl').map(t => (
                        <tr key={t.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                          <td style={{ padding: '12px 16px' }}>
                            {t.datos_adicionales?.placa_referencia ? (
                              <span className="plate-badge-sm">{t.datos_adicionales.placa_referencia}</span>
                            ) : (
                              <span style={{ color: '#94a3b8' }}>—</span>
                            )}
                          </td>
                          <td style={{ padding: '12px 16px', fontSize: '14px', color: '#334155' }}>
                            {t.tramite_type_name}
                          </td>
                          <td style={{ padding: '12px 16px', fontSize: '13px' }}>
                            <span style={{ background: '#e0e7ff', color: '#3730a3', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>
                              {t.transito_name || '—'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-actions" style={{ borderTop: '1px solid #e2e8f0', paddingTop: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <button 
                onClick={handleDownloadExcel}
                style={{ 
                  background: '#dcfce7', 
                  color: '#16a34a', 
                  border: '1px solid rgba(22, 163, 74, 0.2)', 
                  padding: '8px 16px', 
                  borderRadius: '6px', 
                  cursor: 'pointer',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '14px'
                }}
              >
                📥 Descargar Excel
              </button>
              <button 
                className="btn-secondary" 
                onClick={() => setShowPendingCuplModal(false)}
                style={{ padding: '8px 16px', borderRadius: '6px', fontWeight: '600' }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      <VerificarSoatsModal
        isOpen={showVerificarSoatsModal}
        onClose={() => setShowVerificarSoatsModal(false)}
        onVerificacionComplete={fetchTramites}
      />

      <TramiteEliminacionesModal
        isOpen={showEliminacionesModal}
        requests={deletionRequests}
        onClose={() => setShowEliminacionesModal(false)}
        onSuccess={fetchTramites}
      />

      <TramiteRequestDeletionModal
        isOpen={showRechazarModal}
        tramite={selectedTramiteForRechazo}
        onClose={() => {
          setShowRechazarModal(false);
          setSelectedTramiteForRechazo(null);
        }}
        onConfirm={handleRechazarTransito}
      />

      <SolicitudesCambioPlacaModal
        isOpen={showCambioPlacaModal}
        onClose={() => setShowCambioPlacaModal(false)}
        onSuccess={fetchTramites}
      />
    </div>
  );
};

export default BandejaTransito;
